import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
  CreateWorkflowVariableRequest,
  UpdateWorkflowVariableRequest,
  WorkflowVariableDefinitionInfo,
} from '@blaze-shared/api-contracts-domain';
import { GetParamsObj, XhrService } from '@blaze-shared/platform-data-access';

@Injectable({ providedIn: 'root' })
export class WorkflowVariablesApiService {
  private readonly xhrService = inject(XhrService);

  get({
    includeReferences,
    projectId,
    workflowId,
  }:
    | { projectId: string; workflowId?: never; includeReferences?: boolean }
    | { projectId?: never; workflowId: string; includeReferences?: boolean }): Observable<
    WorkflowVariableDefinitionInfo[]
  > {
    // only one of the params can be specified at the time
    const params: GetParamsObj = { includeReferences: !!includeReferences };
    if (projectId) {
      params.projectId = projectId;
    }
    if (workflowId) {
      params.workflowId = workflowId;
    }

    return this.xhrService.get<WorkflowVariableDefinitionInfo[]>(`workflowvariables`, params);
  }

  create(
    variableDefinition: CreateWorkflowVariableRequest,
  ): Observable<WorkflowVariableDefinitionInfo> {
    return this.xhrService.post<WorkflowVariableDefinitionInfo, CreateWorkflowVariableRequest>(
      `workflowvariables`,
      variableDefinition,
    );
  }

  delete(workflowVariableId: string): Observable<unknown> {
    return this.xhrService.delete(`workflowvariables/${workflowVariableId}`);
  }

  update(
    workflowVariableId: string,
    variableDefinition: UpdateWorkflowVariableRequest,
  ): Observable<WorkflowVariableDefinitionInfo> {
    return this.xhrService.put<WorkflowVariableDefinitionInfo, UpdateWorkflowVariableRequest>(
      `workflowvariables/${workflowVariableId}`,
      variableDefinition,
    );
  }
}
